import type {CSSProperties,ReactNode} from 'react';
import type {Card} from '@platform/contracts/x';
import {cardLabel} from '@platform/ui/cardLabel';
import {useUi} from '@platform/ui/config';

export function CardBadge({card,label=cardLabel(card),title=cardLabel(card),muted=false,children}:{card:Pick<Card,'id'|'name'|'colorGroup'>;label?:string;title?:string;muted?:boolean;children?:ReactNode}){
 const ui=useUi(),group=ui.cardAppearance.groups[(card.colorGroup??(ui.cardAppearance.assignments as Record<string,string>)[card.id]) as keyof typeof ui.cardAppearance.groups];
 return <strong className="room-card-badge" data-card-badge={card.id} data-muted={muted||undefined} title={title} aria-label={title} style={{'--moving-accent':group?.accent,'--moving-ink':group?.ink} as CSSProperties}>{label}{children}</strong>;
}
